// extracted by css-extract-rspack-plugin
export default {"root":"FileListGallery_root__9gC3r"};